<template lang="pug">
    extends ../base/base.pug
    block input
        label(
        v-bind:for="slug"
        )
            = '{{ question }}'
            span(
            v-if="is_required"
            class="requiredField"
            ) *
        b-form-textarea(
            v-model="local_answer"
            :id="slug"
            :placeholder="placeholder"
            v-on:blur.native="process_change()"
            :required="is_required"
            :state="get_state"
            :rows="3"
        )
        b-form-invalid-feedback
            = '{{ error_message }}'
        b-form-text
            = '{{ helper }}'
</template>
<script>
import Base from "../base";

export default {
	extends: Base,
	props: ["placeholder"]
};
</script>
